import { gql, useMutation } from '@apollo/client';
import { GET_USER } from '@dieterApi/user/useUserQuery';
import { DPO_INFO_FIELDS, DpoInfo, GET_DPO_INFO } from './useDpoInfoQuery';

const ASSIGN_DPO = gql`
  ${DPO_INFO_FIELDS}
  mutation AssignDpo($companyId: String!, $userId: String!) {
    assignDpo(companyId: $companyId, userId: $userId) {
      ...DpoInfoFields
    }
  }
`;

export interface AssignDpoResult {
  assignDpo: DpoInfo;
}

export interface AssignDpoInput {
  companyId: string;
  userId: string;
}

export function useAssignDpoMutation(companyId: string) {
  return useMutation<AssignDpoResult, AssignDpoInput>(ASSIGN_DPO, {
    refetchQueries: [
      { query: GET_DPO_INFO, variables: { companyId } },
      { query: GET_USER },
    ],
  });
}
